import { gql } from "@apollo/client";

export const SAVE_CALL = gql`
    mutation saveCall($data: CreateCallInput!) {
        saveCall(data: $data)
    }
`;

export default SAVE_CALL;
